<template>
  <div
    data-component-group="billing-form"
    data-component="edit"
    class="elevation-1"
  >
    <ConflictsPanel v-if="hasConflict" :conflict="item.conflict">
      <template v-slot:beforeForm>
        <layout-section-header
          title="Detected conflicts"
          :has-trigger="false"
        />
      </template>
    </ConflictsPanel>

    <BillingForm
      :billingItem="item"
      confirm-trigger-label="Update billing"
      :is-disabled="!canEditDetails"
      :is-loading="isLoading"
      :on-submit="onSubmit"
      :is-on="isOn"
      :is-edit="true"
    >
      <template v-slot:beforeForm>
        <layout-section-header
          title="Details"
          :trigger-label="detailsTriggerLabel"
          :has-trigger="canUpdateBilling"
          @toggle="toggleEditDetails"
        />
      </template>
    </BillingForm>
  </div>
</template>

<script>
  import BillingForm from './AddNew';
  import ConflictsPanel from '../../panels/billing/Conflicts';
  import { isObj } from '../../../utils';

  export default {
    components: {
      BillingForm,
      ConflictsPanel,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isOn: {
        type: Boolean,
        default: false
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        canEditDetails: false,
      };
    },
    computed: {
      detailsTriggerLabel() {
        return this.canEditDetails ? 'Close' : 'Edit details';
      },
      hasConflict() {
        return isObj(this.item.conflict);
      },
      canUpdateBilling() {
        return this.$ability.can('update', 'billing');
      },
    },
    watch: {
      item(nextItem) {
        if (isObj(nextItem)) {
          this.canEditDetails = false;
        }
      },
    },
    methods: {
      toggleEditDetails() {
        this.canEditDetails = !this.canEditDetails;
      },
    },
  };
</script>
